import { useState } from "react";
import { toast } from "sonner";
import { Download, Mail, Send } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { CouponQr } from "./WalkinCredits";

export async function downloadCouponPdf(authAxios, code) {
  try {
    const r = await authAxios.get(`/coupons/${code}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url; a.download = `coupon-${code}.pdf`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch { toast.error("Could not download coupon"); }
}

export default function CouponReprint({ coupon, onEmailed }) {
  const { authAxios } = useAuth();
  const [email, setEmail] = useState(coupon.issued_to_email || "");
  const [sending, setSending] = useState(false);
  if (!coupon.reprintable) return null;

  const send = async () => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) return toast.error("Enter a valid email");
    setSending(true);
    try {
      const r = await authAxios.post(`/coupons/${coupon.code}/email`, { email: email.trim() });
      toast.success(`Coupon emailed to ${r.data.email}`);
      onEmailed?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Email failed"); }
    finally { setSending(false); }
  };

  return (
    <div className="bg-white rounded-2xl p-4 shadow-sm mb-4 space-y-3" data-testid="coupon-reprint">
      <p className="text-xs text-slate-500 text-center">Ask the buyer to photograph the QR, download the PDF or send it by email.</p>
      <div className="flex justify-center">
        <CouponQr credit={{ coupon_code: coupon.code, amount: coupon.balance }} testid="coupon-reprint-qr" />
      </div>
      <button onClick={() => downloadCouponPdf(authAxios, coupon.code)} className="w-full py-2.5 rounded-full border-2 border-[#1e3a5f] text-[#1e3a5f] font-semibold text-sm flex items-center justify-center gap-1.5" data-testid="coupon-reprint-pdf-btn">
        <Download className="w-4 h-4" /> Download PDF
      </button>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Mail className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="buyer@example.com"
            className="w-full pl-9 pr-3 py-2.5 rounded-xl border text-sm" data-testid="coupon-reprint-email-input" />
        </div>
        <button onClick={send} disabled={sending || !email.trim()} className="px-4 rounded-xl bg-[#1e3a5f] text-white font-semibold text-sm flex items-center gap-1.5 disabled:opacity-50" data-testid="coupon-reprint-email-btn">
          <Send className="w-4 h-4" /> {sending ? "…" : "Email"}
        </button>
      </div>
    </div>
  );
}
